<div class="callback-loading">
  <img src="assets/loading.gif" alt="loading" width="100" height="100">
</div>